// extracted by mini-css-extract-plugin
module.exports = {"bigContainer":"Detail_bigContainer__2SaSu","container":"Detail_container__2hAnP","loading":"Detail_loading__d3YNa"};